import React from 'react';
import { fmtCurrency, humanizeEnum } from '../utils/format';

export const SCAN_FIELD_LABELS = {
  title: 'Title',
  lightsparkEntity: 'Lightspark entity',
  contractType: 'Contract type',
  counterparty: 'Counterparty',
  additionalCounterparties: 'Additional counterparties',
  counterpartyContact: 'Contact note',
  counterpartyContactName: 'Contact name',
  counterpartyContactEmail: 'Contact email',
  counterpartyContactPhone: 'Contact phone',
  counterpartyContactRole: 'Contact role',
  effectiveDate: 'Effective date',
  expirationDate: 'Expiration date',
  renewalType: 'Renewal type',
  renewalNoticeDays: 'Renewal notice (days)',
  terminationNoticeDays: 'Termination notice (days)',
  contractValue: 'Contract value',
  paymentTerms: 'Payment terms',
};

export function formatScanValue(key, value) {
  if (value === null || value === undefined || value === '') return '—';
  if (key === 'contractType' || key === 'renewalType' || key === 'paymentTerms') {
    return humanizeEnum(value);
  }
  if (key === 'contractValue' && typeof value === 'number') {
    return fmtCurrency(value, 'USD', { empty: '—' });
  }
  if (key === 'additionalCounterparties') {
    let parties = Array.isArray(value) ? value : [];
    if (!parties.length && typeof value === 'string') {
      try {
        const parsed = JSON.parse(value);
        parties = Array.isArray(parsed) ? parsed : [];
      } catch (_) {
        parties = value.trim() ? [value] : [];
      }
    }
    if (!parties.length) return '—';
    return parties
      .map((party) => {
        if (typeof party === 'string') return party;
        if (!party || typeof party !== 'object') return null;
        return [party.name || party.counterparty || party.party, party.role || party.relationship || party.type]
          .filter(Boolean)
          .join(' - ');
      })
      .filter(Boolean)
      .join('; ');
  }
  return String(value);
}

export function ScanSectionHeader({ icon, title, count }) {
  return (
    <div className="row" style={{ gap: 6, alignItems: 'center' }}>
      {icon}
      <span style={{ fontSize: 12, fontWeight: 500, color: 'var(--text-primary)' }}>{title}</span>
      <span className="muted" style={{ fontSize: 11 }}>({count})</span>
    </div>
  );
}
